<template>
  <div>
    <span
      @click="ordered ? showOrderDetails() : ''"
      :class="ordered ? 'kayako' : ''"
      :title="ordered ? 'Check order status' : ''"
      >{{ orderInfo.orderID }}</span
    >
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  data: () => ({
    orderInfo: {
      orderID: "",
    },
    ordered: null,
  }),
  methods: {
    showOrderDetails() {
      let vm = this;
      vm.params.clicked(vm.orderInfo);
    },
  },
  beforeMount() {
    let vm = this;
    if (vm.params) {
      vm.orderInfo = vm.params.data;
      vm.ordered = vm.params.data.msn !== null && vm.params.data.msn !== "";
    }
  },
});
</script>

<style>
.kayako {
  text-decoration: underline;
  color: #2f5578 !important;
  cursor: pointer;
  font-weight: bold;
}
</style>
